import {ManagedCampaigns} from '@/content/pages/managed-campaigns/index';

export default {
  icon: require('@/assets/icons/services/content_creation_icon.png'),
  title: 'iGaming Outreach',
  url: '/services/casino-link-building',
  meta: {
    title: '',
    // TODO
  },
} as ManagedCampaigns;
